module.exports = __webpack_public_path__ + "assets/a1499db1ac5949f6a3637fb58fb7e02f.json";